import emojiData from "@emoji-mart/data";
import EmojiPicker from "@emoji-mart/react";
import { Popover } from "@jugl-web/ui-kit";
import { FC } from "react";
import { useEditorToolbar } from "../RichTextarea";
import { ToolbarButton } from "../TextToolbar";
import { ReactComponent as EmojiIcon } from "./assets/emoji.svg";

interface EmojiButtonProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const EmojiButton: FC<EmojiButtonProps> = ({ onOpenChange }) => {
  const { insertText } = useEditorToolbar();

  return (
    <Popover
      placement="top-start"
      onMount={() => onOpenChange?.(true)}
      onUnmount={() => onOpenChange?.(false)}
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={ToolbarButton}
          ref={triggerRef}
          name="Emoji"
          icon={<EmojiIcon />}
          isActive={isOpen}
        />
      )}
    >
      {({ onClose }) => (
        <EmojiPicker
          theme="light"
          data={emojiData}
          skinTonePosition="none"
          previewPosition="none"
          onEmojiSelect={(emoji: { native: string }) => {
            insertText(emoji.native);
            onClose();
          }}
        />
      )}
    </Popover>
  );
};
